import { render, staticRenderFns } from "./PdPaymentList.vue?vue&type=template&id=643f661a&scoped=true&"
import script from "./PdPaymentList.vue?vue&type=script&lang=js&"
export * from "./PdPaymentList.vue?vue&type=script&lang=js&"
import style0 from "./PdPaymentList.vue?vue&type=style&index=0&id=643f661a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643f661a",
  null
  
)

export default component.exports